import React from 'react';
import { Mail, Phone, MessageSquare, Printer } from 'lucide-react';
import './MonivaeFooter.css';

const MonivaeFooter = () => {
  return (
    <footer className="monivae-footer">
      <div className="container">
        <div className="monivae-footer-content">
          <div className="monivae-footer-section">
            <img 
              src="/images/logos/clinical-minds-logo-white.png" 
              alt="Clinical Minds Psychology Logo" 
              className="monivae-footer-logo"
            />
            <p className="body-small">
              Collaborative, Compassionate and Practical Psychology Services, Australia Wide
            </p>
          </div>
          
          <div className="monivae-footer-section">
            <h4 className="monivae-footer-title">Contact</h4>
            <div className="monivae-footer-contact">
              <div className="monivae-contact-item">
                <Phone size={16} />
                <span><a href="tel:0266002710">02 6600 2710 (phone)</a></span>
              </div>
              <div className="monivae-contact-item">
                <MessageSquare size={16} />
                <span><a href="sms:0415220944">0415 220 944 (SMS)</a></span>
              </div>
              <div className="monivae-contact-item">
                <Printer size={16} />
                <span><a href="tel:0266991457">02 6699 1457 (Fax)</a></span>
              </div>
              <div className="monivae-contact-item">
                <Mail size={16} />
                <span><a href="mailto:contact@clinicalminds.net">contact@clinicalminds.net</a></span>
              </div>
            </div>
          </div>
        </div>
        
        <div className="monivae-footer-bottom">
          <p className="body-small">
            © {new Date().getFullYear()} Clinical Minds Psychology. All rights reserved.
          </p>
          <div className="monivae-footer-legal-links">
            <a 
              href="/Clinical_Minds_Privacy_Policy.pdf" 
              target="_blank" 
              rel="noopener noreferrer"
              className="monivae-footer-legal-link"
            >
              Privacy Policy
            </a>
            <span className="monivae-footer-separator">•</span>
            <a 
              href="/Clinical_Minds_Terms_and_Conditions.pdf" 
              target="_blank" 
              rel="noopener noreferrer"
              className="monivae-footer-legal-link"
            >
              Terms & Conditions
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default MonivaeFooter;
